/**
 * Phone layout (below `md`): inside a server or an open DM the top server
 * rail is hidden so the conversation gets its ~60px back, and the rail moves
 * to the top of the channel drawer. On the DM list (nothing open) it stays on
 * top. The left (vertical) rail is desktop-only and never moves.
 */
export function railInDrawer(args: {
  phone: boolean;
  verticalRail: boolean;
  guildId: string | null;
  channelId: string | null;
}): boolean {
  return args.phone && !args.verticalRail && (args.guildId !== null || args.channelId !== null);
}
